import { string } from 'prop-types'
import React from 'react'
import styles from './ListItem.module.scss'
const ListItemV2 = ({ title, value }) => {
  return (
    <div className={styles.ItemWrap}>
      <span className={styles.ItemTitle}>{title}</span>
      <span className={styles.ItemValue}>{value}</span>
    </div>
  )
}
ListItemV2.propTypes = {
  title: string.isRequired,
  value: string
}

export default ListItemV2
